import React, {Component} from 'react';
import { graphql, gql , compose} from 'react-apollo'
// import { Button ,Col, Row, Card, Icon} from 'antd'
import PostFb from './Component/PostFb'
// import Image from './Component/Image'
import './style.css'

class Confirm extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            button: 'Share to Facebook',
            icon: 'share-alt'
        }
    }
    handleShare = () => {
        this.setState({
            loading: true,
            button: 'Sharing',
            icon: ''
        })
        this.props.postFB({
            variables: {
                bib: parseInt(this.props.bib, 10),
                slug: this.props.event.slug
            }
        }).then(res => res.data.postFb)
        .then(val => {
            if(val[0]){
                this.setState({
                    loading: false,
                    button: 'Shared',
                    icon: 'check'
                })
            } else {
                console.error('response' , val)
                console.error('falied')
            }
        })
    }
    render() {
            // console.log(this.props.data.times)
            if(!this.props.data.times) {
                return <div>loading</div>
            }
        return (
            <div>
                 {this.props.data.times&&this.props.data.times[0]?
                    <div>
                         {/* <div className="wrap-thank" style={{marginBottom: 20}}>
                            <h1>Hello <span style={span}>{this.props.name}</span> Bib: <span style={span}>{this.props.bib}</span></h1>
                            <h1>ระบบได้แชร์ Checkpoint ของคุณเรียบร้อยแล้ว</h1>
                        </div>
                        <Row type="flex" justify="start">
                            <Col span={24}>
                                <Button type="primary" size="large" loading={this.state.loading} onClick={this.handleShare}>
                                    <Icon type={this.state.icon}/> {this.state.button}
                                </Button>
                            </Col>
                        </Row>
                        <Row type="flex" justify="center">
                        {this.props.data.times.filter(value => !value.eSlip).map((time, index) => (
                            <Col key={index} md={{span:12}}>
                                <Card style={{margin: 10}}>
                                    <Image link={time.link} />
                                    <div className="custom-card">
                                        <h3>{time.CheckPointName}</h3>
                                    </div>
                                </Card>
                            </Col>
                        ))}
                        </Row> */}
                        <PostFb event={this.props.event} bib={this.props.bib} />
                    </div>:
                    <div className="wrap-thank">
                        <h1>Name: <span style={span}>{this.props.name}</span> Bib: <span style={span}>{this.props.bib}</span></h1>
                        <h1>Registration complete</h1>
                        <h1>Thank You</h1>
                    </div>
                 } 
            </div>
        );
    }
}
const span = {
    fontWeight: "normal"
}

const withQuery = gql`
query findTime($bibNumber: Float!, $event:String!){
  times(filter:{
    bibNumber:$bibNumber,
    event:$event
  }){
    _id,
    link
  }
}
`

const withPost = gql `
mutation postFB( $bib: Int!, $slug: String!){
  postFb(
    recode:{
      bib: $bib,
      slug: $slug
    }
  )
}
`
export default compose(
    graphql(withQuery,{
        options:(props) => ({
            variables: {
                bibNumber: props.bib,
                event: props.event.event
            }
        })
    }),
    graphql(withPost, {
        name: 'postFB'
    })
)(Confirm)


// WEBPACK FOOTER //
// ./src/Login/Thanks.js